import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

// Bounce to /login on any 401 (expired session). Skip the auth/me probe itself.
api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        if (status === 401 && !url.endsWith("/auth/me") && !url.endsWith("/auth/login")) {
            if (typeof window !== "undefined" && window.location.pathname !== "/login") {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    },
);

// --- auth ---
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogin = (password) =>
    api.post("/auth/login", { password }).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);

// --- existing endpoints ---

export const getStats = () => api.get("/stats").then((r) => r.data);
export const listActions = (status) =>
    api.get("/actions", { params: status ? { status } : {} }).then((r) => r.data);
export const getAction = (id) => api.get(`/actions/${id}`).then((r) => r.data);
export const retryAction = (id) => api.post(`/actions/${id}/retry`).then((r) => r.data);
export const resolveAction = (id) => api.post(`/actions/${id}/resolve`).then((r) => r.data);
export const sendToReview = (id) => api.post(`/actions/${id}/review`).then((r) => r.data);
export const approveAction = (id) => api.post(`/actions/${id}/approve`).then((r) => r.data);
export const editAction = (id, body) => api.post(`/actions/${id}/edit`, body).then((r) => r.data);
export const dismissAction = (id) => api.post(`/actions/${id}/dismiss`).then((r) => r.data);
export const listWorkflows = () => api.get("/workflows").then((r) => r.data);
export const runWorkflow = (id, body) =>
    api.post(`/workflows/${id}/run`, body).then((r) => r.data);
export const seedDemo = () => api.post("/seed").then((r) => r.data);
